import React from 'react';
import BaseApi from "../../utils/BaseApi";
import {CircularProgress, Stack} from "@mui/joy";
import Box from '@mui/joy/Box';
import Typography from "@mui/joy/Typography";

// components
import RouteEntityAdmin from "./RouteEntityAdmin";


class RouteAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveEntities();
    }

    async retrieveEntities() {
        const url = `route/entities/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        await this.setState(
            {
                categories: response.data,
            }
        );
    }

    render() {
        if (!this.state.categories) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <Stack
                    direction={'column'}
                >
                    {this.state.categories.map(each => {
                        return(
                            <>
                                <Typography level={'h1'}>
                                    {each[1]}
                                </Typography>
                                <Box>
                                    <RouteEntityAdmin
                                        entity={each[0]}
                                    />
                                </Box>
                            </>
                        )
                    })}
                </Stack>
            </Box>
        )
    }
}

export default RouteAdmin